import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	/* For grid layout (necessary for resizing widgets) */
	/* display: grid;
	grid-template-columns: repeat(6, 1fr);
	grid-template-rows: masonry;
	gap: 2rem;
	margin-top: 2rem;
	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
		grid-template-columns: 1fr;
	} */

	display: flex;
	flex-flow: row wrap;
	flex-basis: content;
	justify-items: stretch;
	gap: 2rem;
	margin-top: 2rem;
	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
	}
`;
